// extracted by mini-css-extract-plugin
module.exports = {"container":"_1wPNJ","placeholder":"_17YWs"};